export type LoginFlowStyle = Partial<{
  blockClassName: string
  headerClassName: string
  subHeaderClassName: string
  innerClassName: string
  titleClassName: string
  subTitleClassName: string
  introClassName: string
  formClassName: string
  formInnerClassName: string
  formAlertClassName: string
  formAlertErrorClassName: string
  formAlertWarningClassName: string
  formAlertSuccessClassName: string
  formGroupClassName: string
  formGroupCheckboxClassName: string
  formGroupRadioClassName: string
  formBooleanLabelClassName: string
  formBooleanInputClassName: string
  formBooleanErrorClassName: string
  formInputClassName: string
  formSelectClassName: string
  formLabelClassName: string
  formFieldErrorClassName: string
  formFieldFeedbackInvalidClassName: string
  formFieldFeedbackClassName: string
  formActionsClassName: string
  clickableWrapperClassName: string
  clickablePrimaryClassName: string
  clickableSecondaryClassName: string
  clickableTertiaryClassName: string
  footerClassName: string
  footerItemClassName: string
}>

export const LoginFlowClasses: LoginFlowStyle = {
  blockClassName: "loginflow lf",
  headerClassName: "lf__header",
  subHeaderClassName: "lf__subheader",
  titleClassName: "lf__title title--s",
  subTitleClassName: "lf__subtitle title--xs",
  introClassName: "lf__intro text--styled",
  formClassName: "lf__form",
  formInnerClassName: "lf__form-inner",
  formAlertClassName: "lf__alert text--styled",
  formAlertErrorClassName: "lf__alert--error",
  formAlertWarningClassName: "lf__alert--warning",
  formAlertSuccessClassName: "lf__alert--success",
  formGroupClassName: "lf__group form-group",
  formGroupCheckboxClassName: "lf__group lf__group--checkbox form-group",
  formGroupRadioClassName: "lf__group lf__group--radio form-group",
  formLabelClassName: "lf__label",
  formInputClassName: "lf__input",
  formSelectClassName: "lf__select",
  formBooleanInputClassName: "",
  formBooleanLabelClassName: "text--styled",
  formFieldErrorClassName: "lf__invalid is-invalid",
  formFieldFeedbackInvalidClassName: "lf__error invalid-feedback",
  formFieldFeedbackClassName: "lf__description",
  formActionsClassName: "lf__actions",
  clickableWrapperClassName: "lf__action",
  clickablePrimaryClassName: "button--primary button--s",
  clickableSecondaryClassName: "",
  clickableTertiaryClassName: "",
  footerClassName: "lf__options text--styled text--s",
  footerItemClassName: "lf__option",
}
